var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-16"},[_c('img',{attrs:{"src":"/happy.svg","alt":"","width":"48"}}),_c('p',{staticClass:"mt-8"},[_c('strong',[_vm._v(_vm._s(_vm.ready_title))]),_vm._v("."),_c('br'),_vm._v(" "+_vm._s(_vm.ready_desc)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }